import { Component } from '@angular/core';
import { MissionService } from '../../../services/mission.service';
import { CandidatStatusOnMission } from '../../../shared/utils/enums';
import { addDays } from 'date-fns';
import { CookieService } from 'ngx-cookie-service';
import {candidatAccepted} from "../../../shared/utils/data/shared.data";

@Component({
  selector: 'app-planning',
  templateUrl: './planning.component.html',
  styleUrl: './planning.component.scss',
})
export class PlanningComponent {
  randomData: any[] = [];
  events: any[] = [];
  CandidatStatusOnMission = CandidatStatusOnMission;
  condidatId: number;
  user: any;
  constructor(
    private api: MissionService,
    private cookieService: CookieService
  ) {
    this.condidatId = this.user?.id;
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.fetshMission();
  }
  fetshMission(): void {
    this.api.getMissionsByEtablissment(6).subscribe({
      next: (res) => {
        this.user = res?.persons[0];
        this.events = res?.missions?.candidatesApplied?.filter((c:any) => candidatAccepted.includes(c.statusOfCandidatOnMission)).map((el: any, key: any) => {
          let date1: any = new Date(el.startdate);
          let date2: any = new Date(el.enddate);
          const diffTime = Math.abs(date2 - date1);
          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

          if (diffDays) {
            return {
              id: el?.id,
              start: new Date(el.startdate + ' ' + el?.starttime),
              end: new Date(el.enddate + ' ' + el?.endtime),
              title: el?.missionTitle || 'Mission ' + el?.id,
              etablissementNom: el?.etablissementNom,
              allDay: true,
              data: {
                ...el,
                user: {
                  ...this.user,
                  numsiret: res.numsiret,
                  typeSecteur: el.typeSecteur,
                },
              },
            };
          } else {
            return {
              id: el?.id,
              start: new Date(el.startdate),
              end: new Date(el.startdate),
              title: el?.missionTitle || 'Mission ' + el?.id,
              etablissementNom: el?.etablissementNom,
              allDay: true,
              data: {
                ...el,
                user: {
                  ...this.user,
                  numsiret: res.numsiret,
                  typeSecteur: el.typeSecteur,
                },
              },
            };
          }
        });
        this.randomData = res?.missions?.map((el: any) => {
          return {
            title: el?.missionTitle || 'Mission ' + el?.id,
            secteur: el.typeSecteur || 'N/A',
            contractType:
              el?.typecontat == 'LIBERAL' ? 'INTÉRIM' : el?.typecontat,
            startDate: el.startdate,
            endDate: el.enddate,
            renumeration: el.compensationproposednet || 0,
            candidatures: el.candidatures || 'N/A',
            currency: '$',
            status:
              el.missionStatus ||
              CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION,
          };
        });
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {},
    });
    // this.api
    //   .getMissions()
    //   .then((res : any) => {

    //   })
    //   .catch((err : any) => {
    //     console.log(err);
    //   });
  }
}
